import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { CommentsButtonNew } from '../../components/CommentsButtonNew';
import { trackOpenCommentsBlock as trackCommentsBlockOpen } from '../../components/comments/button/tracking';
import { getCommentBlock, selectIsAuthenticated } from '../../selectors';
import { changeEdditing, closeComments, openComments, openCommentsAfterAuth } from '../../store/comments';
import { callAuthenticationPopup } from '../../utils/authentication';
import { useApplicationContext } from '../ApplicationContext';

export function CommentsButtonContainer() {
  const dispatch = useDispatch();
  const { microfrontendsAPI } = useApplicationContext();
  const { isOpen, commentText } = useSelector(getCommentBlock);
  const isAuthenticated = useSelector(selectIsAuthenticated);

  const clickHandle = React.useCallback(() => {
    if (isOpen) {
      if (commentText) {
        return;
      } else {
        dispatch(closeComments());
      }
    } else {
      if (!isAuthenticated) {
        callAuthenticationPopup(microfrontendsAPI, { source: 'note', viewData: { headingType: 'addNote' } });
        dispatch(openCommentsAfterAuth());
      } else {
        dispatch(changeEdditing(true));
        dispatch(openComments());
      }
      trackCommentsBlockOpen();
    }
  }, [commentText, isOpen, isAuthenticated, microfrontendsAPI, dispatch]);

  return <CommentsButtonNew commented={isOpen} onClick={clickHandle} />;
}
